import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { toast } from 'react-toastify';
import logo from '../../assets/logo.png';
import { signOutMed } from '../../store/modules/auth/doctor/actions';
import { signOutFunc } from '../../store/modules/auth/funcionario/actions';
import styles from '../../styles.module.css';
import history from '../../services/history';
import { startQrAuth } from '../../services/vidaasV2';
import isMedicoExterno from '../../util/medicoHelpers';
import canAccessAdministracao from '../../util/canAccessAdministracao';

export default function NavBar() {
  const { profile: medico } = useSelector(state => state.doctor);
  const { funcionario } = useSelector(state => state.funcionario);
  const dispatch = useDispatch();
  const showAdminMenu = canAccessAdministracao(medico, funcionario);

  const autenticarComVidaas = async event => {
    try {
      event.preventDefault();
      const { authorizationUrl } = await startQrAuth();
      window.location.assign(authorizationUrl);
    } catch (error) {
      toast.error(
        error?.response?.data?.error || 'Erro ao autenticar com VIDAAS!'
      );
    }
  };

  return medico && isMedicoExterno(medico) ? (
    <Navbar bg="success" expand="lg" className={styles.navbarLink}>
      <Navbar.Brand>
        <img src={logo} alt="logo" width={50} height={50} />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto">
          <Nav.Link onClick={() => history.push('/frmatv')}>Exames</Nav.Link>
          <Nav.Link
            onClick={() => {
              dispatch(signOutMed());
              dispatch(signOutFunc());
            }}
          >
            Sair
          </Nav.Link>
        </Nav>
        <Navbar.Text>
          Usuário: {medico ? medico.apelido : new Date().toDateString()}
        </Navbar.Text>
      </Navbar.Collapse>
    </Navbar>
  ) : (
    <Navbar bg="success" expand="lg" className={styles.navbarLink}>
      <Navbar.Brand>
        <img src={logo} alt="logo" width={50} height={50} />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto">
          <Nav.Link onClick={() => history.push('/agenda')}>Agenda</Nav.Link>
          <Nav.Link onClick={() => history.push('/frmatv')}>Exames</Nav.Link>
          <Nav.Link onClick={e => autenticarComVidaas(e)}>Autenticar</Nav.Link>
          <Nav.Link onClick={() => history.push('/form-medico')}>
            Médicos
          </Nav.Link>
          {showAdminMenu && (
            <NavDropdown title="Administração" id="admin-nav-dropdown">
              <NavDropdown.Item onClick={() => history.push('/admin/convenios')}>
                Convênio
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={() => history.push('/admin/procedimentos')}
              >
                Procedi
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={() => history.push('/admin/atividades')}
              >
                Atividade
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={() => history.push('/admin/funcionarios')}
              >
                Usuários
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={() => history.push('/dicionarios')}>
                Dicionários
              </NavDropdown.Item>
            </NavDropdown>
          )}
          <Nav.Link
            onClick={() => {
              dispatch(signOutMed());
              dispatch(signOutFunc());
            }}
          >
            Sair
          </Nav.Link>
        </Nav>
        <Navbar.Text>
          Usuário: {medico ? medico.apelido : funcionario?.nome}
        </Navbar.Text>
      </Navbar.Collapse>
    </Navbar>
  );
}
